import { Ref } from 'vue'

export const popoverProvision = Symbol('d-popover')

export type Children = Map<
symbol,
{
  popover: { el: HTMLElement; children: Children }
  update: () => void
  changeShowState: (v: boolean, options: { immediate: boolean; force: boolean }) => void
}>

export interface PopoverProvision {
  children: Ref<Children>
}
